import { createUseStyles } from 'react-jss'
import { boldFont, textSize, color } from 'styles/helpers'
import config from 'styles/config'

export default createUseStyles(theme => ({
  subscriptionRecapTitle: {
    ...color('textDefault', theme.theme),
    ...textSize(14, 19),
    ...boldFont(),
    marginBottom: 4
  },
  subscriptionItem: {
    ...color('textDefault', theme.theme),
    ...textSize(14, 19),
    '& b': {
      fontWeight: 500
    }
  },
  help: {
    ...color('textDefault', theme.theme),
    ...textSize(14, 19),
    marginBottom: 32
  },
  subscriptionList: {
    marginBottom: 32
  },
  table: {
    ...textSize(14, 19),
    borderCollapse: 'collapse',
    width: '100%',
    marginBottom: 32
  },
  thead: {
    ...color('textSecondary', theme.theme)
  },
  row: {
    borderBottom: `1px solid ${config.colors.boxSeparator}`,
    '& td': {
      padding: `8px 0`,
    }
  },
  priceCell: {
    whiteSpace: 'nowrap',
    textAlign: 'right'
  }
}))
